import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { DocumentSupportService } from './../../../../services/shopping/document-support.service';
import { Component, OnInit, Optional } from '@angular/core';
import { DocumentSupportModel } from 'src/app/models/shopping/document-support.model';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { ToastrService } from 'ngx-toastr';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-copy-document-support',
  templateUrl: './copy-document-support.component.html',
  styleUrls: ['./copy-document-support.component.scss'],
  standalone: false
})
export class CopyDocumentSupportComponent implements OnInit {

  inputs$: BehaviorSubject<any>;
  output$: Subject<any>;
  subscription: Subscription;

  documentSupportId: number;
  listBussinessDocumentsTypes: CustomListDropdown[] = [];

  bussinessDocumentsTypeId: number = 0;
  consecutive: number = 0;

  constructor(
    public config: DynamicDialogConfig,
    private documentSupportService: DocumentSupportService,
    private toastr: ToastrService,
    @Optional() private ref: DynamicDialogRef) {
  }

  ngOnInit(): void {
    const inputs$ = this.config.data?.inputs$;
    if (!inputs$) {
      console.error('no definido en config data');
      return;
    }
    this.subscription = inputs$?.subscribe((inputs: any) => {
      this.documentSupportId = inputs.documentSupportId;
      this.listBussinessDocumentsTypes = inputs.listBussinessDocumentsTypes ?? [];
    })
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  close() {
    if (this.ref) this.ref.close();
  }

  async copyDocumentSupport() {
    if (this.bussinessDocumentsTypeId === 0 || this.bussinessDocumentsTypeId === null) {
      this.toastr.warning('Debe seleccionar un tipo de Doc. Comercial válido.', 'Atención.', {
        timeOut: 5000, progressBar: true, closeButton: true
      });
      return;
    }
    if (this.consecutive == 0 || this.consecutive == null) {
      this.toastr.warning('Debe ingresar un número de Documento soporte válido.', 'Atención.', {
        timeOut: 5000, progressBar: true, closeButton: true
      });
      return;
    }
    try {
      let response = await firstValueFrom(this.documentSupportService.copyDocumentSupport(this.documentSupportId, this.bussinessDocumentsTypeId, this.consecutive))
      this.toastr.success('El Documento soporte fue copiado exitosamente.', '', {
        timeOut: 5000, progressBar: true, closeButton: true
      });
      this.updateDocumentSupportEmit(response);
      this.close();
    } catch (error) {
      this.close();
      console.error('Error al copiar la el Documento soporte.', error);
      this.toastr.error('Error al copiar el Documento soporte.', 'Error', {
        timeOut: 5000, progressBar: true, closeButton: true
      });
    }
  }

  async getBussinessDocumentsType(bussinessDocumentsTypeId: number | null) {
    if (bussinessDocumentsTypeId != null && bussinessDocumentsTypeId != 0) {
      this.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
    } else {
      this.bussinessDocumentsTypeId = 0;
    }
  }

  updateDocumentSupportEmit(documentSupportModel: DocumentSupportModel) {
    const output$ = this.config.data?.output$;
    output$?.next({ type: 'updateDocumentSupport', payload: documentSupportModel })
  }
}
